import { Link } from "react-router-dom";
import BackArrow from "../assets/images/back-arrow.svg";
import HeartIcon from "../assets/images/heart_logo_unity.png";
import FacePrint from "../assets/images/face-print.svg";
import VoiceTest from "../assets/images/voice-test.svg";
import CoughTest from "../assets/images/caugh-test.svg";
import QuickQuestion from "../assets/images/quick-qustion.svg";

const FacePulmoDashboard = () => {
  return (
    <section className="pt-2 pb-14 lg:pb-24 flex flex-col tab-screen">
      <div className="px-6">
        <div className="flex items-center mb-20 w-full relative z-50">
          <Link
            to={-1}
            className=" w-9 h-9 bg-[#2D2D2D] rounded-full flex flex-row justify-center items-center"
          >
            <img src={BackArrow} alt="" />
          </Link>
          <h2 className="text-2xl font-medium text-white lg:text-2xl md:text-2xl ml-6">
            UnityHealth
          </h2>
          <div></div>
        </div>
      </div>
      <div className=" -mt-20">
        <div className="circle-blur w-[70%] h-64 mx-auto mt-28 blur-[60px] absolute left-0 right-0"></div>
        <img
          src={HeartIcon}
          className="lg:w-6/12 w-[250px] lg:rounded-full mx-auto mt-5"
          alt=""
        />
      </div>
      <div className="px-6 lg:px-0 w-full mx-auto -mt-28 relative z-50">
        <div className="bg-[#1D1D1D]/70 rounded-[20px] p-4">
          <h2 className="text-base lg:text-3xl font-semibold text-secondary text-center mb-2 mt-2">
            Digital Health Screening{" "}
          </h2>
          <p className="text-xs lg:text-sm font-light text-white text-center leading-3 mb-2">
            Advanced Health Biomarkers and Risk Scores
            <br /> from Voice & Facial Analysis
          </p>
          <p className="text-center text-secondary font-extralight text-[8px] lg:text-xs mb-4">
            Follow these simple steps to complete your assessment:
          </p>
          <ul className="flex flex-row justify-between flex-wrap px-4">
            <li className="w-[45%] mb-5">
              <img src={FacePrint} className="w-6 h-6" alt="" />
              <h6 className="text-xxs lg:text-base text-white font-semibold mb-1 mt-2">
                60-Second Face Scan
              </h6>
              <p className="text-[9px] lg:text-sm text-white text-justify font-extralight">
                Place your face on the camera and stay still. We'll analyze your
                lung function through a PPG signal.
              </p>
            </li>
            <li className="w-[45%] mb-5">
              <img src={VoiceTest} className="w-6 h-6" alt="" />
              <h6 className="text-xxs lg:text-base text-white font-semibold mb-1 mt-2">
                Voice Test: Vowel /A/
              </h6>
              <p className="text-[9px] lg:text-sm text-white text-justify font-extralight">
                Say /A/ like in "Day" and hold the sound for 6 seconds. We'll
                assess your respiratory health through your voice.
              </p>
            </li>
            <li className="w-[45%] mb-5">
              <img src={CoughTest} className="w-6 h-6" alt="" />
              <h6 className="text-xxs lg:text-base text-white font-semibold mb-1 mt-2">
                Cough Test
              </h6>
              <p className="text-[9px] lg:text-sm text-white text-justify font-extralight">
                Cough naturally into the microphone for 10 seconds. This helps
                us detect any potential lung issues.
              </p>
            </li>
            <li className="w-[45%] mb-5">
              <img src={QuickQuestion} className="w-6 h-6" alt="" />
              <h6 className="text-xxs lg:text-base text-white font-semibold mb-1 mt-2">
                Quick Questionnaire
              </h6>
              <p className="text-[9px] lg:text-sm text-white text-justify font-extralight">
                Answer a few health-related questions to help us refine your
                results.
              </p>
            </li>
          </ul>
          <Link
            to="/pulmo-facescan-instruction"
            // state={{ scanType: "face" }}
            className="lg:w-5/12 md:w-5/12 w-11/12 mx-auto rounded-full outline-none px-5 h-10 bg-white text-primary flex flex-row justify-center items-center mb-2"
          >
            Proceed
          </Link>
        </div>
      </div>
      <div className="w-full lg:px-0 px-6 lg:mb-0 mb-4">
        <div className="mt-4 p-5 rounded-[20px] bg-[#364560] text-white space-y-1.5">
          <h3 className="text-sm font-medium text-secondary">Disclaimer</h3>
          <p className="text-xxs text-justify font-light leading-4 text-white/80">
            For Investigational Use Only. Careplix is not a substitute for the
            clinical judgment of a health care professional. Careplix is
            intended to improve your awareness of general wellness. Careplix
            does not diagnose, treat, mitigate or prevent any disease, symptom,
            disorder or abnormal physical state. Consult with a health care
            professional or emergency services if you believe you may have a
            medical issue.
          </p>
        </div>
      </div>

      {/* <Link to={-1} className="block mt-4 text-sm font-medium  text-white">
      Back
    </Link> */}
    </section>
  );
};

export default FacePulmoDashboard;
